import React, { useEffect, useState } from "react";
import { HostedForm } from "react-acceptjs";
import { postNotification } from "../../../../components/utilities/Notifications";
import { Button, Grid, useTheme } from "@mui/material";
import ModalLoadingFull from "../../../../components/modals/ModalLoadingFull";
import { postData } from "../../../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../../../global/environmentVariables";
const IS_DEV = getEnvironmentVariable("IS_DEV") === "true";

export default function AuthorizeHostedForm(props) {
  const {
    event,
    transactionQueued,
    playerData,
    paymentData,
    loading,
    setLoading,
    setTicketModal
  } = props;
  const theme = useTheme();

  const [authData, setAuthData] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [authorizeResponse, setAuthorizeResponse] = useState(null);
  useEffect(() => {
    if (!transactionQueued?.authorizeNetKeys) {
      postNotification("error", "Organization not setup for payments");
    } else {
      setAuthData({
        apiLoginID: transactionQueued.authorizeNetKeys.apiLoginKey,
        clientKey: transactionQueued.authorizeNetKeys.clientKey
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setLoading(false);
    // eslint-disable-next-line
  }, [authData]);

  useEffect(() => {
    if (authorizeResponse) {
      doSubmit(authorizeResponse);
    }
    // eslint-disable-next-line
  }, [authorizeResponse]);

  const doSubmit = async (response) => {
    try {
      var transaction = await postData(
        `/transactions/${transactionQueued.id}/authorizenetChargeCard`,
        {
          body: {
            [event.teamEvent ||
            event.doublesEvent ||
            event?.format?.teamEvent ||
            event?.format?.doublesEvent
              ? "captainData"
              : "playerData"]: playerData,
            paymentData: paymentData,
            opaqueData: response.opaqueData,
            encryptedCardData: response.encryptedCardData
          }
        }
      );

      window.location.assign(
        `/transaction/${transaction.transactionId}/receipt?orderId=${transaction.transactionOrderId}`
      );
    } catch (err) {
      postNotification("error", err);
    }
    setProcessing(false);
  };

  const handleSubmit = (response) => {
    setProcessing(true);
    setAuthorizeResponse(response);
  };

  return (
    <Grid container spacing={1} sx={{ mt: 2 }}>
      <Grid item xs={6}>
        <Button
          disabled={loading}
          color="error"
          fullWidth
          variant="outlined"
          onClick={() => {
            setTicketModal(2);
          }}
        >
          Back
        </Button>
      </Grid>
      <Grid item xs={6}>
        {loading ? (
          <Button
            disabled
            color="success"
            fullWidth
            variant="outlined"
            onClick={() => {
              setTicketModal(2);
            }}
          >
            Pay
          </Button>
        ) : (
          <HostedForm
            authData={authData}
            onSubmit={handleSubmit}
            environment={IS_DEV ? "SANDBOX" : "PRODUCTION"}
            billingAddressOptions={{ show: false, required: false }}
            buttonStyle={{
              cursor: "pointer",
              outline: 0,
              border: 0,
              margin: 0,
              fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
              fontWeight: "500",
              fontSize: "0.875rem",
              lineHeight: "1.75",
              letterSpacing: "0.02857em",
              textTransform: "uppercase",
              minWidth: "64px",
              padding: "6px 16px",
              borderRadius: "4px",
              backgroundColor: theme?.palette?.success.main,
              color: theme?.palette?.success.contrastText,
              boxShadow:
                "0 0 1px 0 rgb(0 0 0 / 31%), 0 2px 2px -2px rgb(0 0 0 / 25%)",
              width: "100%",
              "&:hover": {
                textDecoration: "none",
                backgroundColor: theme?.palette?.success.dark,
                boxShadow:
                  "0 0 1px 0 rgb(0 0 0 / 31%), 0 3px 4px -2px rgb(0 0 0 / 25%)"
              }
            }}
          />
        )}
      </Grid>
      {processing && <ModalLoadingFull />}
    </Grid>
  );
}
